import 'css-chunksrc/client/scenes/milestoneCreation/milestoneCreationForm/styles.scss';export default {
  "milestoneCreationForm": "_milestoneCreationForm_1szr4_1",
  "projectSelectionRow": "_projectSelectionRow_1szr4_5",
  "group": "_group_1szr4_9",
  "title": "_title_1szr4_18",
  "dateGroup": "_dateGroup_1szr4_23",
  "listSelect": "_listSelect_1szr4_32",
  "dateTimeInput": "_dateTimeInput_1szr4_36",
  "row": "_row_1szr4_41",
  "textArea": "_textArea_1szr4_50"
};